import './403.scss';

const error403 = () => {

  return (
    <main className="error">
      <h1 className="error-title">Erreur 403, tu n'as rien à faire la !</h1>
      <p className="error-content">Voici un petit lien pour <a href="/">retourner à l'accueil</a></p>
    </main>
  );
};

export default error403;
